import React__default from 'react';
import { Button } from '@vp/swan';

const ResponseButtons = ({ onSaveSelections, onCancel, saveChangesLabel, revertChangesLabel, }) => {
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Button, { skin: "primary", width: "full-width", mb: "4", onClick: onSaveSelections }, saveChangesLabel),
        React__default.createElement(Button, { width: "full-width", onClick: onCancel }, revertChangesLabel)));
};

export { ResponseButtons };
//# sourceMappingURL=ResponseButtons.mjs.map
